import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
// import { ArtistEventListComponent } from "./artist-event-list/artist-event-list.component";
import { ArtistPageComponent } from "./components/artist-page.component";
import { ArtistDetailResolver } from "./resolvers/artist-detail.resolver";

const routes: Routes = [
    {
      path: '',
      component: ArtistPageComponent,
      resolve: {
        // Yayında olmayan sanatçı sayfalarını (active/showEventPage false)
        // sanatçı listesine 301 ile yönlendirir.
        artistDetail: ArtistDetailResolver
      }
    }

  ];

  @NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: [ArtistDetailResolver]
  })
  export class ArtistRoutingModule {
  }
